// This file contains the base URL for the GraphQL API
export const graphqlBaseUrl = `${process.env.REACT_APP_API_BASE_URL}/graphql/hotels`;
